$(function () {

    function trackLocatorDealerSelectEvent(element, containerClass) {
        const interactionType = getInteractionType(element);

        if (interactionType && interactionType != '') {
            var container = element.closest(containerClass);
            if (container) {
                const dealerId = container.data('dealer-id');
                const dealerName = container.data('dealer-name');
                const selectedProductType = $('#ProductTypeName').val() || '';
                pushLocatorDealerSelectEvent(interactionType, dealerId, dealerName, selectedProductType);
            }
        }
    }

    function pushLocatorDealerSelectEvent(interactionType, dealerId, dealerName, selectedProductType) {
        if (interactionType && dealerId && dealerName && selectedProductType) {
            dataLayer.push({ event: 'gtm.clear' });
            dataLayer.push({
                'event': 'locatorDealerSelect',
                'interaction_type': interactionType,
                'dealer_id': dealerId,
                'dealer_name': dealerName,
                'product_filter': selectedProductType
            });
        }
    }

    function getInteractionType($element) {
        if ($element.hasClass('analytics_locator-phone')) {
            return 'phone';
        }

        if ($element.hasClass('analytics_locator-email')) {
            return 'email';
        }

        if ($element.hasClass('analytics_locator-website')) {
            return 'website';
        }

        if ($element.hasClass('analytics_locator-directions')) {
            return 'directions';
        }

        return '';
    }

    // Track clicks on dealer panel, dealer details modal, and info content modal
    $(document).on('click', '.dealer-panel-primary a, .dealer-panel-primary button', function () {
       trackLocatorDealerSelectEvent($(this) , '.dealer-panel-primary');
    });

    $(document).on('click', '.dealerDetails a, .dealerDetails button', function () {
        trackLocatorDealerSelectEvent($(this), '.dealerDetails');
    });

    $(document).on('click', '.info_content a, .info_content button', function () {
        trackLocatorDealerSelectEvent($(this), '.info_content');
    });

});